import { Component } from '@angular/core';
import { CaseModel } from '../../models/case.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalA11yService } from '../../services/modal-a11y.service';
import { AuthService } from 'src/app/services/auth.service';
import { StorageService } from '../../services/storage.service';
import { MeService } from 'src/app/services/me.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-filehandler-details',
  standalone: true,
  imports: [],
  templateUrl: './filehandler-details.component.html',
  styleUrl: './filehandler-details.component.scss'
})
export class FilehandlerDetailsComponent {
    case: CaseModel;
    returnUrl: string;
   
    constructor(
        private route: ActivatedRoute,
        private modalA11y: ModalA11yService,
        private authService: AuthService,
        private storage: StorageService,
        private router: Router,
        private meService: MeService,
        private stateService: StateService
    ) { }

    ngOnInit(): void {
        this.case = this.route.snapshot.data.case;
        this.modalA11y.open(this);

        //Disable the account
        this.meService.disableAccount(this.storage.getItem('username')).subscribe();

        this.storage.removeItem('user');
        this.storage.removeItem('username');
        this.storage.removeItem('isendofclaim');
        this.storage.removeItem('token');

        this.authService.isLoggedIn = false;
        this.authService.isLoggingOut.next(null);
    }

    loadRecite(): void {
        this.stateService.showRecite();
    }

    close() {

        // get return url from route parameters or default to null
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || null;

        setTimeout(() => {
            console.log("this.returnUrl", this.returnUrl);
            this.router.navigate(['auth/login'], { queryParams: { returnUrl: this.returnUrl } });
        }, 500);
    }
}
